import config from 'configAlias';
import entries from 'lodash/entries';
import get from 'lodash/get';
import isArray from 'lodash/isArray';
import isPlainObject from 'lodash/isPlainObject';
import * as analyticsUtils from './utils';

export const trackPageView = action => {
  const viewProperties = get(config.analytics, 'view', {});

  const { eventPropertiesAtKeyPath } = analyticsUtils.getPropertiesAtKeyPath(
    action,
    viewProperties
  );

  if (eventPropertiesAtKeyPath) {
    const payload = {
      ...eventPropertiesAtKeyPath,
      tealium_event: 'view',
    };

    if (__DEV__) {
      // eslint-disable-next-line no-console
      console.log('window.TMS.trackView', payload);
    }

    if (window.TMS) {
      return window.TMS.trackView(payload);
    }
  }

  return null;
};

const trackEvent = eventProperties => {
  const payload = {
    ...eventProperties,
    event_category: 'content',
    tealium_event: 'link',
  };

  if (__DEV__) {
    // eslint-disable-next-line no-console
    console.log('window.TMS.trackEvent', payload);
  }

  if (window.TMS) {
    return window.TMS.trackEvent(payload);
  }
};

export const trackEventAtKeyPath = (action, type) => {
  if (!type) throw new Error('type is required');

  const eventProperties = get(config.analytics, `event.${type}`, {});

  const { eventPropertiesAtKeyPath } = analyticsUtils.getPropertiesAtKeyPath(
    action,
    eventProperties
  );

  if (eventPropertiesAtKeyPath) {
    return trackEvent(eventPropertiesAtKeyPath);
  }

  return null;
};

export const trackEventsForPage = (pageName, action) => {
  const eventProperties = get(config.analytics, 'event.onNavigate', {});

  return (function recurse(keyPath) {
    const { eventPropertiesAtKeyPath, formValuesAtKeyPath } =
      analyticsUtils.getPropertiesAtKeyPath(
        {
          ...action,
          keyPath,
        },
        eventProperties
      );

    if (
      typeof formValuesAtKeyPath !== 'undefined' &&
      formValuesAtKeyPath !== null &&
      eventPropertiesAtKeyPath
    ) {
      return trackEvent(eventPropertiesAtKeyPath);
    }

    if (isArray(formValuesAtKeyPath)) {
      return formValuesAtKeyPath.forEach((_, index) => {
        recurse(analyticsUtils.extendKeyPath(keyPath, { index }));
      });
    }

    if (isPlainObject(formValuesAtKeyPath)) {
      return entries(formValuesAtKeyPath).forEach(([propertyName]) => {
        recurse(analyticsUtils.extendKeyPath(keyPath, { propertyName }));
      });
    }

    return null;
  })({ pageName });
};
